const initialState = {
  roomList: [],
  buildingList: [],
  bookingAddReason: [],
  floorsList: [],
  siteId: null,

  // Separate state for hierarchical location data
  locationData: {
    adminSiteId: null,
    adminBuildingsList: [],
    adminFloorsList: [],
    adminRoomsList: [],
    sites: []
  },

  // Filtered instruments state
  filteredInstruments: {
    loading: false,
    instruments: [],
    error: null,
    activeRequestId: null,
  }
};

export default initialState;
